<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/property-definition' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.CreateProperty") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Precinct')"
              >
                <vs-input
                  :label="$t('setup.label.Precinct')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="precinct"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PropertyCode')"
              >
                <vs-input
                  :label="$t('setup.label.PropertyCode')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="propertyCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Parcel')"
              >
                <vs-input
                  :label="$t('setup.label.Parcel')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="parcel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.PropertyType")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.PropertyType')"
                >
                  <v-select
                    label="mCodeValue"
                    v-if="propertyTemplateData && propertyTemplateData.propertyTypes"
                    :options="propertyTemplateData.propertyTypes"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    v-model="propertyType"
                  >
                    <template v-slot:option="option">
                      {{ option.mCodeValue }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BuildingCode')"
              >
                <vs-input
                  :label="$t('setup.label.BuildingCode')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="buildingCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PoBox')"
              >
                <vs-input
                  :label="$t('setup.label.PoBox')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="poBox"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Floor')"
              >
                <vs-input
                  :label="$t('setup.label.Floor')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="floor"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.UnitCode')"
              >
                <vs-input
                  :label="$t('setup.label.UnitCode')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="unitCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Street") }} / {{ $t("setup.label.Area")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Street')"
                >
                  <v-select
                    label="cityName"
                    v-if="propertyTemplateData && propertyTemplateData.citiesData"
                    :options="propertyTemplateData.citiesData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.cityName"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    v-model="street"
                  >
                    <template v-slot:option="option">
                      {{ option.cityName }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.State')"
              >
                <vs-input
                  :label="$t('setup.label.State')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="state"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Country')"
              >
                <vs-input
                  :label="$t('setup.label.Country')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="country"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button @click="handleSubmit" class="mr-3 mb-2 footerButton-next">
            {{ $t("setup.label.Submit") }}
          </vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      precinct: "",
      propertyCode: "",
      parcel: "",
      propertyType: "",
      poBox: "",
      buildingCode: "",
      street: "",
      state: "",
      floor: "",
      country: "",
      unitCode: "",
      errorMessage: "",
      warningPopup: false,
      warningText: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      propertyTemplateData: (state) =>
        state.propertyDefinition.propertyTemplate,
    }),
  },
  methods: {
    resetForm() {
      this.precinct = "";
      this.propertyCode = "";
      this.parcel = "";
      this.propertyType = "";
      this.poBox = "";
      this.buildingCode = "";
      this.street = "";
      this.state = "";
      this.floor = "";
      this.country = "";
      this.unitCode = "";

      this.$refs.observer.reset();
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        propertyCode: this.propertyCode,
        propertyType: this.propertyType,
        unitCode: this.unitCode,
        floor: this.floor,
        buildingCode: this.buildingCode,
        parcel: this.parcel,
        precinct: this.precinct,
        poBox: this.poBox,
        street: this.street,
        state: this.state,
        country: this.country,
      };
      try {
        await this.$store.dispatch(
          "propertyDefinition/createPropertyAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Property Created Successfully!",
          type: "success",
        });
        this.$router.push("/setup/property-definition");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getPropertyTemplateMethod() {
      try {
        await this.$store.dispatch(
          "propertyDefinition/getPropertyTemplateAction"
        );
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },

  async mounted() {
    await this.getPropertyTemplateMethod();
  },
};
</script>
